import React, { useState } from "react";
import styles from "./CopyLink.module.css";

const CopyIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
  </svg>
);

interface CopyButtonProps {
  referralLink: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ referralLink }) => {
  const [isCopied, setIsCopied] = useState(false);

  
  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000); // El mensaje "Copiado" desaparece después de 2s
    });
  };

  return (
    <div className="flex w-full">
      <input
        type="text"
        readOnly
        value={referralLink}
        className={`${styles.linkInput} min-w-0 flex-grow`}
      />
      <button onClick={handleCopy} className={`${styles.copyButton} flex-shrink-0`}>
        {isCopied ? "¡Copiado!" : <CopyIcon />}
      </button>
    </div>
  );
};
